import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  AddDocumentArg,
  AddDocumentResponse,
  EmployedType,
  QueryParamsPaginationEmployedsType,
  QueryParamsTabEmployedsType,
  ResponseEmployedType,
  ResponsePaginationEmployedsType,
  TabEmployedsItemType,
  TabEmployedsResponseType,
} from './type';

const getToken = () => localStorage.getItem('token');

const getAuthorizationHeader = () => {
  const token = getToken();
  return token ? `Bearer ${token}` : '';
};

export const employedsWorkSupportApi = createApi({
  reducerPath: 'employedsWorkSupportApi',
  tagTypes: ['Employeds', 'Employed', 'Tags', 'EmployedsTabs'],
  refetchOnReconnect: true,
  keepUnusedDataFor: 15,
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/api/worksupport`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: getAuthorizationHeader(),
    },
  }),
  endpoints: (build) => ({
    getEmployedsWorkSupport: build.query<EmployedType[], void>({
      query: () => ({
        url: `workers-app`,
        method: 'GET',
      }),
      providesTags: () => ['Employeds'],
    }),
    getEmployed: build.query<ResponseEmployedType, { id: number | null }>({
      query: ({ id }) => ({
        url: `/workers-app/${id}`,
        method: 'GET',
      }),
      providesTags: () => ['Employed'],
    }),
    deleteEmployed: build.mutation<ResponseEmployedType, { id: number | null }>({
      query: ({ id }) => ({
        url: `/workers-app/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: () => ['Employeds'],
    }),
    addDocument: build.mutation<AddDocumentResponse, AddDocumentArg>({
      query: ({ id, body }) => ({
        url: `/workers-app/${id}/document`,
        method: 'POST',
        body,
      }),
      invalidatesTags: () => ['Employed'],
    }),
    getTabEmployeds: build.query<TabEmployedsItemType[], QueryParamsTabEmployedsType>({
      query: ({ id, title }) => ({
        url: `/workers-app/${id}/tabs/${title}`,
        method: 'GET',
      }),
      providesTags: () => ['Tags'],
      transformResponse: (response: TabEmployedsResponseType) => response?.items,
    }),
    getTabPaginationEmployeds: build.query<
      ResponsePaginationEmployedsType,
      QueryParamsPaginationEmployedsType
    >({
      query: ({ page, per_page, search }) => ({
        url: `/v2/workers-app/`,
        method: 'GET',
        params: { page, per_page, search },
      }),
      providesTags: () => ['Tags'],
    }),
  }),
});

export const {
  useGetTabEmployedsQuery,
  useGetEmployedQuery,
  useGetEmployedsWorkSupportQuery,
  useGetTabPaginationEmployedsQuery,
  useDeleteEmployedMutation,
  useAddDocumentMutation,
} = employedsWorkSupportApi;
